export default __webpack_public_path__ + "static/media/info-circle.3d0ba229.svg";